import React, { Component } from 'react';
import PropTypes from 'prop-types';
import __ from '../../helpers/translation';

const propTypes = {
  callback: PropTypes.func.isRequired,
  sortText: PropTypes.string,
  disabled: PropTypes.bool
};

class SortBox extends Component {

    constructor (props) {
      super(props);
      /*this.state = {
        'callback': props.callback,
        'searchText': props.searchText ? props.searchText : '',
        'disabled': props.disabled ? props.disabled : false
      };*/
    }

    sort(text) {
       /* this.setState({
            'searchText': text
        });*/
        this.props.callback(text);
    }

    render () {
        return (
            
            <div className="form-label-group">
                <select
                    defaultValue={'sort_by_date_desc'}
                    onChange={e => this.sort(e.target.value)}
                    className="form-control sort-input my-4"
                >
                    <option value="sort_by_date_desc">{ __('app.general.sort_by_date_desc') }</option>
                    <option value="sort_by_date_asc">{ __('app.general.sort_by_date_asc') }</option>
                    <option value="sort_by_name_asc">{ __('app.general.sort_by_name_asc') }</option>
                    <option value="sort_by_name_desc">{ __('app.general.sort_by_name_desc') }</option>
                </select>
            </div>

        )
    }
}

SortBox.propTypes = propTypes;

export default SortBox;
